/**
 * KM Predictive Search v3.0
 * - Chargé UNE SEULE FOIS depuis layout/theme.liquid
 * - Retry automatique jusqu'à ce que les inputs soient dans le DOM
 * - Couvre desktop (#km-search-input) ET mobile (#km-msb-input)
 * - Structure API correcte : data.resources.results.products
 */
(function () {
  'use strict';

  /* Eviter double initialisation si le script est chargé plusieurs fois */
  if (window.__kmSearchInit) return;
  window.__kmSearchInit = true;

  function fmt(x) {
    return String(Math.round(Number(x))).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00a0FCFA';
  }

  function hl(text, q) {
    if (!q || !text) return text || '';
    try {
      return text.replace(
        new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'),
        '<em>$1</em>'
      );
    } catch (e) { return text; }
  }

  function initSearch(inputId, sugId) {
    var input = document.getElementById(inputId);
    var sug   = document.getElementById(sugId);

    /* Si les éléments ne sont pas encore dans le DOM, on réessaie */
    if (!input || !sug) {
      setTimeout(function() { initSearch(inputId, sugId); }, 150);
      return;
    }

    /* Éviter double écoute sur le même input */
    if (input.dataset.kmSearchReady) return;
    input.dataset.kmSearchReady = '1';

    var timer = null, lastQ = '', activeIdx = -1;

    function close() {
      sug.classList.remove('is-open');
      sug.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIdx = -1;
    }

    function render(resources, q) {
      var products = [];

      /* Structure correcte API Shopify : resources.results.products */
      if (resources && resources.results) {
        products = Array.isArray(resources.results.products) ? resources.results.products : [];
      }
      /* Fallback */
      if (!products.length && resources && resources.products && Array.isArray(resources.products.results)) {
        products = resources.products.results;
      }

      var html = '';

      if (products.length) {
        html += '<div class="km-search-sug-section"><div class="km-search-sug-label">Produits</div>';
        products.slice(0, 10).forEach(function (p) {
          var priceVal = (p.price != null && p.price !== '') ? p.price : p.price_min;
          var price = priceVal ? fmt(priceVal) : '';
          var cmp = (p.compare_at_price_min && Number(p.compare_at_price_min) > Number(priceVal)) ? fmt(p.compare_at_price_min) : '';
          var img = p.featured_image ? p.featured_image.url : '';
          html += '<a class="km-search-sug-item" href="' + p.url + '">';
          if (img) html += '<img class="km-search-sug-img" src="' + img + '" alt="" loading="lazy">';
          else     html += '<div class="km-search-sug-img-placeholder"></div>';
          html += '<div class="km-search-sug-info">';
          html += '<div class="km-search-sug-title" style="white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.4;">' + hl(p.title, q) + '</div>';
          if (price) {
            html += '<div class="km-search-sug-price">' + price;
            if (cmp) html += '<s class="km-search-sug-compare" style="color:#9aa0a6;font-size:0.9em;font-weight:500;margin-left:8px;">' + cmp + '</s>';
            html += '</div>';
          }
          html += '</div></a>';
        });
        html += '</div>';
      }

      if (html) {
        html += '<div class="km-search-sug-footer">Voir tous les r\u00e9sultats \u2014 <a href="/search?q=' + encodeURIComponent(q) + '"><strong>\u00ab\u00a0' + q + '\u00a0\u00bb</strong></a></div>';
        sug.innerHTML = html;
        sug.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      } else {
        close();
      }
      activeIdx = -1;
    }

    function doSearch(q) {
      if (q.length < 2) { close(); return; }
      if (q === lastQ) return;
      lastQ = q;
      fetch(
        '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10' +
        '&resources[options][unavailable_products]=last'
      )
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (input.value.trim() === q && data) {
            render(data.resources, q);
          }
        })
        .catch(function (err) {
          console.warn('[KM Search] Erreur:', err);
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); lastQ = ''; return; }
      timer = setTimeout(function () { doSearch(q); }, 200);
    });

    input.addEventListener('keydown', function (e) {
      var items = sug.querySelectorAll('.km-search-sug-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); }
      else if (e.key === 'Escape') { close(); input.blur(); return; }
      else return;
      items.forEach(function (el, i) { el.classList.toggle('active', i === activeIdx); });
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= 2) { lastQ = ''; doSearch(q); }
    });

    /* Sur mobile : événement 'input' peut ne pas se déclencher sur certains claviers virtuels
       On ajoute 'compositionend' et 'keyup' comme fallback */
    input.addEventListener('keyup', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); lastQ = ''; return; }
      if (q === lastQ) return;
      timer = setTimeout(function () { doSearch(q); }, 200);
    });

    input.addEventListener('compositionend', function () {
      var q = input.value.trim();
      if (q.length >= 2) { lastQ = ''; doSearch(q); }
    });

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !sug.contains(e.target)) close();
    });

    document.addEventListener('touchstart', function (e) {
      if (!input.contains(e.target) && !sug.contains(e.target)) close();
    }, { passive: true });
  }

  function boot() {
    initSearch('km-search-input', 'km-search-sug');   /* Desktop */
    initSearch('km-msb-input', 'km-msb-suggestions'); /* Mobile  */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();

/* ===== KM — Bandeau noir (topheader) : couleur + espacement des liens (n'affecte pas la barre verte km-topbar) ===== */
(function () {
  if (window.__kmTopheaderStyle) return;
  window.__kmTopheaderStyle = true;
  var css =
    '.topheader a{color:#fff !important;text-decoration:none;font-weight:700;white-space:nowrap;display:inline-flex;align-items:center;margin:0 7px;}'
  + '.topheader a:hover{opacity:.85;}'
  + '.topheader a[href*="wa.me"]::before,.topheader a[href^="tel:"]::before{content:"";display:inline-block;width:15px;height:15px;margin-right:4px;background-size:contain;background-repeat:no-repeat;background-position:center;}'
  + '.topheader a[href*="wa.me"]::before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2IDNDOC44IDMgMyA4LjggMyAxNmMwIDIuNS43IDQuOSAxLjkgNi45TDMgMjlsNi4zLTEuOEMxMS4yIDI4LjMgMTMuNSAyOSAxNiAyOWM3LjIgMCAxMy01LjggMTMtMTNTMjMuMiAzIDE2IDN6bTAgMjMuNmMtMi4zIDAtNC40LS43LTYuMi0xLjlsLS40LS4zLTMuNyAxIDEtMy42LS4zLS40QzUuOSAxOS45IDUuMiAxOCA1LjIgMTYgNS4yIDEwIDEwIDUuMiAxNiA1LjJTMjYuOCAxMCAyNi44IDE2IDIyIDI2LjYgMTYgMjYuNnptNi04LjFjLS4zLS4yLTEuOS0xLTIuMi0xLjEtLjMtLjEtLjUtLjItLjguMi0uMi4zLS44IDEuMS0xIDEuMy0uMi4yLS40LjItLjcuMS0uMy0uMi0xLjQtLjUtMi42LTEuNi0xLS45LTEuNi0yLTEuOC0yLjMtLjItLjMgMC0uNS4xLS43LjEtLjEuMy0uNC41LS42LjEtLjIuMi0uMy4zLS42LjEtLjIgMC0uNCAwLS42LS4xLS4yLS44LTEuOS0xLjEtMi42LS4zLS43LS42LS42LS44LS42aC0uN2MtLjIgMC0uNi4xLS45LjQtLjMuMy0xLjIgMS4xLTEuMiAyLjhzMS4yIDMuMiAxLjQgMy41Yy4yLjIgMi40IDMuNyA1LjkgNS4yLjguNCAxLjUuNiAyIC43LjguMyAxLjYuMiAyLjIuMS43LS4xIDItLjggMi4zLTEuNi4zLS44LjMtMS40LjItMS42LS4xLS4xLS4zLS4yLS42LS40eiIvPjwvc3ZnPg==);}'
  + '.topheader a[href^="tel:"]::before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTYuNiAxMC44YzEuNCAyLjggMy44IDUuMSA2LjYgNi42bDIuMi0yLjJjLjMtLjMuNy0uNCAxLS4yIDEuMS40IDIuMy42IDMuNi42LjYgMCAxIC40IDEgMVYyMGMwIC42LS40IDEtMSAxQzEwLjYgMjEgMyAxMy40IDMgNGMwLS42LjQtMSAxLTFoMy41Yy42IDAgMSAuNCAxIDEgMCAxLjIuMiAyLjQuNiAzLjYuMS40IDAgLjctLjIgMWwtMi4zIDIuMnoiLz48L3N2Zz4=);}'
  + '@media (min-width:769px){.topheader{display:none !important;}}'
  + '@media (max-width:768px){.topheader{display:flex !important;align-items:center !important;justify-content:center !important;min-height:30px !important;}.topheader > div{width:100%;}.topheader p{margin:0 !important;line-height:1 !important;display:flex !important;align-items:center !important;justify-content:center !important;flex-wrap:wrap;}}';
  var s = document.createElement('style');
  s.setAttribute('data-km', 'topheader-contacts');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();
